/**
 * @generated SignedSource<<09dfb317669de4998cabfde27d2c44e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCmaReportInput = {
  clientMutationId?: string | null;
  id: string;
};
export type leadCmaCardDeleteCmaReportMutation$variables = {
  input: DeleteCmaReportInput;
};
export type leadCmaCardDeleteCmaReportMutation$data = {
  readonly deleteCmaReport: {
    readonly deletedNodeId: string | null;
  } | null;
};
export type leadCmaCardDeleteCmaReportMutation = {
  response: leadCmaCardDeleteCmaReportMutation$data;
  variables: leadCmaCardDeleteCmaReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCmaReportPayload",
    "kind": "LinkedField",
    "name": "deleteCmaReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedNodeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "leadCmaCardDeleteCmaReportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "leadCmaCardDeleteCmaReportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "43630907490a8698a20ee7426a51b0ae",
    "id": null,
    "metadata": {},
    "name": "leadCmaCardDeleteCmaReportMutation",
    "operationKind": "mutation",
    "text": "mutation leadCmaCardDeleteCmaReportMutation(\n  $input: DeleteCmaReportInput!\n) {\n  deleteCmaReport(input: $input) {\n    deletedNodeId\n  }\n}\n"
  }
};
})();

(node as any).hash = "bba036871f6ec8460a9e9f6abf1d0dbf";

export default node;
